export default __webpack_public_path__ + "static/media/grid1.7da95d3d.jpg";